import React from "react"
import { Parallax } from "react-scroll-parallax"
import Pattern from "../../images/freedom-pattern-top.png"
import FreedomImg from "../../images/home/freedom.svg"

const ParternedHomeSection = () => {
  return (
    <div className="sparkle-freedom position-relative my-5">
      <div className="container ">
        <div className="row justify-content-center py-lg-5 my-lg-5">
          <div className="col-lg-5 pt-lg-5" style={{ zIndex: 2 }}>
            <p className="text-uppercase mt-lg-5 pt-lg-0 pt-4">About Us</p>
            <h4 data-aos="fade-up" data-aos-duration="2000">
              The freedom and transparency your money deserves.
            </h4>
            <h4 className="mt-5" data-aos="fade-up" data-aos-duration="2000">
              With Sparkle, it is more than just banking. It is improving your
              financial lifestyle.
            </h4>
          </div>
          <div className="col-lg-5 offset-lg-2 order-first order-lg-last position-relative">
            <Parallax y={[15, 0]}>
              <img
                loading="lazy"
                src={FreedomImg}
                className="img-fluid position-relative"
                data-aos="reveal-image"
                data-aos-duration="2000"
                alt="With Sparkle it is more than just banking, it is improving  your financial lifestyle"
                title="With Sparkle it is more than just banking, it is improving  your financial lifestyle"
                style={{ zIndex: 1000 }}
              />
            </Parallax>

            <img
              loading="lazy"
              src={Pattern}
              alt="freedom pattern"
              className="img-fluid pattern__one d-none d-lg-block"
              style={{ zIndex: -1 }}
            />

            <img
              loading="lazy"
              src={Pattern}
              alt="freedom pattern"
              className="img-fluid pattern__two d-none d-lg-block"
              style={{ zIndex: -1 }}
            />

            <img
              loading="lazy"
              src={Pattern}
              alt="freedom pattern"
              className="img-fluid pattern__three d-none d-lg-block"
              style={{ zIndex: -1 }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default ParternedHomeSection
